import React, { useState } from "react";
import { useLocation, NavLink } from "react-router-dom";
import { useSelector } from 'react-redux';
import { selectUserData } from '@/store/slices/UserDataSlice';
import { LeftNavItem, LefthandGlobalNavItem } from './LefthandGlobalNavItem';
import { GetBrandedLogo, GetBrandedLogoAltText } from '@/services/BrandingService';
import rightCaret from '@/images/icons/nav-right-caret.svg';
import './LefthandGlobalNav.scss';
import { NavigationId } from "@/enums";

export interface LefthandGlobalNavBarProps {
    items: Array<LeftNavItem>;
    collapseStartState?: boolean;
    previewStartState?: boolean;
}

export const LefthandGlobalNavBar: React.FC<LefthandGlobalNavBarProps> = ({
  items,
  collapseStartState = false,
  previewStartState = false,
}) => {
  const location = useLocation();
  const userData = useSelector(selectUserData);
  const [isCollapsed, setIsCollapsed] = useState(collapseStartState);
  const [isPreviewed, setIsPreviewed] = useState(previewStartState);
  const [activeItem, setActiveItem] = useState((items.find(({route}) => route && location.pathname.includes(route))?['idName'] : "home") as NavigationId);
  const homeRouteByUser = userData?.userType !== "DISTRICT_ADMIN" && userData?.userType !== "SCHOOL_ADMIN"
   ? "/dashboard" : "/admin";
  const navItems = items
    .map(item => ({
      ...item,
      isCollapsed,
      isActive: activeItem === item.idName,
      setActiveItem
    }))
    // Sort by sequence number
    .sort(({sequenceNum: aSequence}, {sequenceNum: bSequence}) => aSequence - bSequence);

  return (
    <nav
      id="nav-primary"
      data-testid="lefthand-nav"
      className={`aec-lefthand-global-nav-bar ${isCollapsed ? "collapsed" : ""} ${isPreviewed ? "previewed" : ""}`}
    >
      <section className="logo-section">
        <NavLink to={homeRouteByUser}>
          <img src={GetBrandedLogo()} alt={GetBrandedLogoAltText()} className="logo" />
        </NavLink>
        <button type="button" className="collapse-button" onClick={() => {
          setIsCollapsed(!isCollapsed && !isPreviewed);
          setIsPreviewed(false);
        }}>
          <img src={rightCaret} alt={`${isCollapsed ? "Click to visually expand menu" : "Click to visually collapse menu"}`} />
        </button>
      </section>
      <ul className="d-flex flex-column">
      {navItems.map(item => (
        <LefthandGlobalNavItem
          key={item.idName}
          {...item}
          isCollapsed={isCollapsed}
          isActive={ activeItem === item.idName }
        />
      ))}
      </ul>
    </nav>
  );
};
